/**
 * Represents the methods through which a [[Member]] can be authenticated.
 *
 * @remarks
 * The values of this enum are in snake case for compatibility with the OAuth specification.
 */
export var MemberAuthenticationGrantType;
(function (MemberAuthenticationGrantType) {
    /**
     * Authenticate using a username or email, and a password.
     */
    MemberAuthenticationGrantType["Password"] = "password";
    /**
     * Authenticate using a refresh token.
     */
    MemberAuthenticationGrantType["RefreshToken"] = "refresh_token";
    /**
     * Authenticate using a device token.
     */
    MemberAuthenticationGrantType["DeviceToken"] = "device_token";
})(MemberAuthenticationGrantType || (MemberAuthenticationGrantType = {}));
//# sourceMappingURL=member-authentication-grant-type.js.map